export default "__VITE_ASSET__N6yR3RfZ__"